/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import React, {createRef, Fragment} from "react";
import {service as FileUploadService} from "../../../Services/FileUploadService";
import autobind from "autobind-decorator";
import {FileUploadOverlay} from "../../../Components/Common/Files/FileUploadOverlay";
import {FileVisibilityHelper} from "../../../Components/Common/Files/FileVisibilityHelper";
import {Button, Col, Row} from "react-bootstrap";

// TODO: Refactor to functional component to remove circular dependencies
export class FileUploadFieldEditor extends BaseFieldEditor {
	constructor() {
		super();

		this.inputField = createRef();

		this.state = {
			uploadProgress: 0,
			fileUpload: null,
			displayUpload: false,
		};
	}

	componentDidMount() {
		const {Value} = this.props;
		const {fileUpload} = this.state;

		if (!fileUpload && Value) {
			FileUploadService.GetFileUpload(Value)
				.then((x) => {
					this.setState({fileUpload: x.result});
				})
				.catch((err) => this.setState({fileUpload: null}));
		} else {
			this.setState({fileUpload: null});
		}
	}

	@autobind
	displayDialog() {
		const {inputField} = this;

		inputField?.current?.click?.();
	}

	@autobind
	downloadFile(fileId) {
		const {fileUpload} = this.state;

		FileUploadService.DownloadFile(fileUpload.fileName, fileId);
	}

	@autobind
	getContextNodeIds() {
		const {FieldDef, RootData} = this.props;
		let contextNodeIds = null;

		if (FieldDef && FieldDef.customData && FieldDef.customData.contextNodeIdFetch) {
			contextNodeIds = FieldDef.customData.contextNodeIdFetch(RootData);
		}

		return contextNodeIds?.filter(x => x)
	}

	@autobind
	getSurveyTypeId() {
		const {CustomData} = this.props;
		let surveyTypeId = null;
		if (CustomData && CustomData?.surveyTypeId) {
			surveyTypeId = CustomData.surveyTypeId;
		}
		return surveyTypeId
	}

	@autobind
	onFileSelect(e) {
		const {files} = e?.target || {};

		if (files.length > 0) {
			this.processFile(files[0]);
		}
	}

	@autobind
	processFile(file) {
		this.setState({uploadProgress: 0, displayUpload: true}, () => {
			const {OnUpdate} = this.props;

			const contextNodeIds = this.getContextNodeIds() ?? [];
			const surveyTypeId = this.getSurveyTypeId();

			FileUploadService.UploadFile(
				file.name,
				file,
				contextNodeIds,
				(a, b) => this.setState({uploadProgress: ((a / b) * 100)}),
				surveyTypeId
			)
				.then((file) => {
					this.setState({uploadProgress: 0, fileUpload: file, displayUpload: false}, () => {
						OnUpdate(file.fileUploadId);
					});
				})
				.catch((x) => {
					this.setState({uploadProgress: 0});
				});
		});
	}

	@autobind
	_render() {
		const {fileUpload, displayUpload, uploadProgress} = this.state;
		const contextNodeIds = this.getContextNodeIds();

		let content = null;
		if (displayUpload) {
			content = <FileUploadOverlay uploadingFiles={1} fileProgress={uploadProgress}/>;
		} else if (contextNodeIds.length) {
			let filename = null;

			if (fileUpload && fileUpload.fileUploadId) {
				filename = <a className="link-primary" onClick={() => this.downloadFile(fileUpload.fileUploadId)}>
					{
						fileUpload ?
							fileUpload.name :
							"N/A"
					}
				</a>;
			}

			content = <Fragment>
                    <span className="filename">
                        {filename ?? "Select A File"}
	                    <FileVisibilityHelper file={fileUpload}/>
                    </span>

				<Button
					className="pndlm-image-upload-button pndlm-button-grey"
					onClick={this.displayDialog}
				>
					{filename ? "Replace" : "Upload"}
				</Button>

				<input
					style={{display: "none"}}
					ref={this.inputField}
					type="file"
					onChange={this.onFileSelect}
					multiple={false}
				/>
			</Fragment>;
		} else {
			return <Row>
				<Col xs={12}>
					<p>Please save before uploading a file.</p>
				</Col>
			</Row>;
		}

		return <div className="sb-survey-form-input-file">{content}</div>;
	}
}
